import React, { useState } from "react";
import { toast } from "react-toastify";
import moment from "moment";
// Redux
import { useSelector } from "react-redux";
// Constants
import { pathHomePage, WEB_SERVICE_DASHBOARD_ROUTE, errorColor, bodyColor } from "../../../../config/constants";
// Components
import {
  Title,
  InfoDiv,
  DataDiv,
  ColumnDataDiv,
  InputDataDiv,
  Label,
  Input,
  DateInputDiv,
  DateInput,
  AlignerDiv,
  SubmitButton,
  CodeText,
} from "./styles";
import Header from "../../../header";
import GoBack from "../../../goBack";
import UseFetch from "../../../../config/useFetch";

const CreateCode = () => {
  const [subscriptionDays, setSubscriptionDays] = useState("");
  const [subscriptionDaysError, setSubscriptionDaysError] = useState(false);
  const [expirationDate, setExpirationDate] = useState("");
  const [expirationDateError, setExpirationDateError] = useState(false);
  const [usageLimit, setUsageLimit] = useState("");
  const [description, setDescription] = useState("");
  const [codesNumber, setCodesNumber] = useState(1);
  const [codesNumberError, setCodesNumberError] = useState(false);
  const [generatedCodes, setGeneratedCodes] = useState([]);
  const environment = useSelector(({ database }) => database.environment);

  const handleCreateCode = (e) => {
    e.preventDefault();

    if (!subscriptionDays || isNaN(subscriptionDays)) {
      setSubscriptionDaysError(true);
      return toast.error("You must enter the subscription days");
    }

    if (expirationDate && !moment(expirationDate).isValid()) {
      setExpirationDateError(true);
      return toast.error("You must enter a valid expiration date");
    }

    if (!codesNumber) {
      setCodesNumberError(true);
      return toast.error("You must enter a number of codes");
    }

    let codeData = {
      DISTRIBUTOR: "Eodyne",
      SUBSCRIPTION_DAYS: subscriptionDays,
      environment,
      codesNumber,
    };

    if (expirationDate) {
      codeData.EXPIRATION_DATE = moment(expirationDate).format("YYYY-MM-DD");
    }
    if (usageLimit) {
      codeData.USAGE_LIMIT = usageLimit;
    }
    if (description) {
      codeData.DESCRIPTION = description;
    }

    UseFetch("post", `${WEB_SERVICE_DASHBOARD_ROUTE}/code/generation`, new AbortController(), codeData)
      .then(({ data }) => {
        if (data.codeGeneration) {
          setGeneratedCodes(data.codes);
          setSubscriptionDays("");
          setExpirationDate("");
          setUsageLimit("");
          setDescription("");
          setCodesNumber(1);
          toast.success("Code created successfully");
        }
      })
      .catch((error) => {
        toast.error("Error sending data, try again");
        console.log("Add code: ", error);
      });
  };

  const onChangeInput = (e, setInput, setInputError) => {
    setInput(Number(e.target.value));
    setInputError(false);
  };

  const enabledDates = (date) => {
    return moment(date).isAfter(moment(), "day");
  };

  const handleSetDate = (date) => {
    setExpirationDate(date);
    setExpirationDateError(false);
  };

  const renderAddCodeForm = () => {
    return (
      <InfoDiv>
        <DataDiv>
          <ColumnDataDiv>
            <InputDataDiv>
              <Label htmlFor="subscriptionDays" fontWeight="bold">
                Subscription days *
              </Label>
              <Input
                type="number"
                id="subscriptionDays"
                value={subscriptionDays}
                onChange={(e) => onChangeInput(e, setSubscriptionDays, setSubscriptionDaysError)}
                error={subscriptionDaysError}
              />
            </InputDataDiv>
            <InputDataDiv>
              <Label htmlFor="usageLimit">Usage limit</Label>
              <Input type="number" id="usageLimit" value={usageLimit} onChange={(e) => setUsageLimit(e.target.value)} />
            </InputDataDiv>
            <InputDataDiv>
              <Label htmlFor="codesNumber">Number of codes</Label>
              <Input
                type="number"
                id="codesNumber"
                value={codesNumber}
                onChange={(e) => onChangeInput(e, setCodesNumber, setCodesNumberError)}
                error={codesNumberError}
              />
            </InputDataDiv>
          </ColumnDataDiv>
          <ColumnDataDiv>
            <InputDataDiv>
              <Label htmlFor="expirationDate">Expiration date</Label>
              <DateInputDiv>
                <DateInput
                  selected={expirationDate}
                  onChange={(date) => handleSetDate(date)}
                  filterDate={enabledDates}
                  placeholderText="dd/mm/yyyy"
                  dateFormat={"dd/MM/yyyy"}
                  border={expirationDateError ? `1px solid ${errorColor}` : `1px solid ${bodyColor}`}
                />
              </DateInputDiv>
            </InputDataDiv>
            <InputDataDiv>
              <Label htmlFor="description">Description</Label>
              <Input type="text" id="description" value={description} onChange={(e) => setDescription(e.target.value)} />
            </InputDataDiv>
          </ColumnDataDiv>
        </DataDiv>
        <AlignerDiv margin="10px 0 20px">
          <SubmitButton onClick={handleCreateCode}>Generate</SubmitButton>
        </AlignerDiv>
        <AlignerDiv>
          {generatedCodes.map((code) => {
            return <CodeText key={code}>{code.slice(0, 4) + "-" + code.slice(4)}</CodeText>;
          })}
        </AlignerDiv>
      </InfoDiv>
    );
  };

  return (
    <>
      <Header />
      <GoBack path={`${pathHomePage}/code-management`} />
      <Title>Create new code</Title>
      {renderAddCodeForm()}
    </>
  );
};

export default CreateCode;
